import { ApiServiceError } from '@goodt-common/api';
import { CoreError, CoreWarning, InfrastructureError, SilentError, WidgetDebugMessage } from '@goodt-wcore/errors';
import { DremioError } from '@goodt-common/dremio';
import { HttpTransportError } from '@goodt-common/net';
import { ErrorInfoType } from './constants';
import { ErrorInfo } from './ErrorInfo';

/**
 *
 * @param {Error} error
 * @return {import('./types').ErrorInfoType['type']}
 */
const resolveErrorType = (error) => {
    if (error instanceof WidgetDebugMessage) {
        return ErrorInfoType.WidgetDebug;
    }
    if (error instanceof CoreError) {
        return ErrorInfoType.CoreError;
    }
    if (error instanceof CoreWarning) {
        return ErrorInfoType.CoreWarning;
    }
    if (error instanceof DremioError) {
        return ErrorInfoType.DremioError;
    }
    if (error instanceof ApiServiceError) {
        return ErrorInfoType.ApiServiceError;
    }
    if (error instanceof HttpTransportError) {
        return ErrorInfoType.ServerError;
    }
    if (error instanceof InfrastructureError) {
        return ErrorInfoType.InfrastructureError;
    }
    if (error instanceof SilentError) {
        return ErrorInfoType.SilentError;
    }
    return null;
};

export class ErrorInfoBuilder {
    static ErrorInfoType = ErrorInfoType;

    /**
     *
     * @param {import('./types').ErrorInfoType['error']} error
     * @param {import('./types').ErrorInfoType['context']} context
     * @param {import('./types').ErrorInfoType['scope']} scope
     * @param {import('./types').ErrorInfoType['message']} message
     * @returns {Readonly<ErrorInfo>}
     */
    static build({ error, context, scope, message }) {
        return Object.freeze(
            new ErrorInfo({
                error,
                context,
                scope: this.buildContextInfo({ scope, context }),
                type: resolveErrorType(error),
                message
            })
        );
    }

    static buildContextInfo({ context, scope }) {
        while ((context?.type?.length > 0 && context?.id?.length > 0) === false) {
            if (context == null) {
                return scope;
            }
            // eslint-disable-next-line no-param-reassign
            context = context.$parent;
        }
        const { type: elem, id } = context;
        return {
            elem,
            id,
            hook: scope
        };
    }
}
